import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import TopBar from 'elements/TopBar/TopBar';
import BasicAccordion from 'elements/BasicAccordion';
import BasicAccordionPdf from 'elements/BasicAccordionPdf';
import { ProjectConfig } from 'Global';
import { getSantoralLabel } from 'hooks/useLabels';
import { getHsfLabel, hsfCelebrationDate, formatHsfDate } from 'utils/hsfSantoral';

export default function HsfSantoralViewer(props: any) {
  const { entry_id } = useParams();
  const langId = localStorage.getItem('lang_id') || '1';
  const [details, setDetails] = useState<any>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setDetails(null); setFailed(false); props.setLoading(true);
    axios.get(ProjectConfig.api_url, {
      params: { request: 'hsf_santoral_details', lang_id: langId, id: entry_id },
      timeout: 15000, signal: controller.signal,
    }).then(response => { if (active) setDetails(response.data); })
      .catch(() => { if (active) setFailed(true); })
      .finally(() => { if (active) props.setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [entry_id, langId, attempt, props.setLoading]);

  const entry = details?.entry;
  const content = details?.content;
  return (
    <div id="HsfSantoralViewer" className="module_container">
      <div className="module_topBar"><TopBar title={getHsfLabel('title')} /></div>
      <div className="module_content">
        {failed ? <div className="CardContents"><p role="alert">{getHsfLabel('load_error')}</p><Button onClick={() => setAttempt(value => value + 1)}>{getHsfLabel('retry')}</Button></div> : entry ? <>
          <div className="CardContents">
            {entry.image && <img src={entry.image} alt={entry.name} style={{ display: 'block', maxWidth: '100%', width: 280, maxHeight: 360, objectFit: 'contain', margin: '0 auto 20px' }} onError={event => { event.currentTarget.style.display = 'none'; }} />}
            <h1>{entry.name}</h1>
            <p>{getHsfLabel(entry.designation)}</p>
            {hsfCelebrationDate(entry) && <p><strong>{getHsfLabel('celebration')}:</strong> {hsfCelebrationDate(entry)}</p>}
            {entry.designation === 'venerable' && <p>{getHsfLabel('no_feast')}</p>}
            {content?.biography_html && <BasicAccordion titulo={getSantoralLabel('biografia')} contenido={content.biography_html} />}
            <h2>{getHsfLabel('chronology')}</h2>
            <dl>{(entry.facts || []).map((fact: any, index: number) => <div key={`${fact.key}-${index}`} style={{ marginBottom: 12 }}>
              <dt><strong>{getHsfLabel(fact.key)}</strong></dt>
              <dd style={{ marginLeft: 0 }}>{[fact.date ? formatHsfDate(fact.date) : '', fact.place, fact.value].filter(Boolean).join(' · ')}</dd>
            </div>)}</dl>
            {content?.prayers_html && <BasicAccordion titulo={getSantoralLabel('oraciones_del_santo')} contenido={content.prayers_html} />}
            {content?.calendar_html && <BasicAccordion titulo={getSantoralLabel('calendario_propio_hsf')} contenido={content.calendar_html} />}
            {content?.lectionary_html && <BasicAccordion titulo={getSantoralLabel('lecturas')} contenido={content.lectionary_html} />}
            {['primeras_visperas', 'oficio_lectura', 'laudes', 'horas_intermedias', 'visperas', 'completas'].map(hour => content?.hours?.[hour] ? <BasicAccordion key={hour} titulo={getSantoralLabel(hour)} contenido={content.hours[hour]} /> : null)}
            {(content?.files || []).map((file: any) => <BasicAccordionPdf key={file.file_id} filePdf={file.file} titulo={file.name} />)}
          </div>
          {details.members?.length > 0 && <><h2>{getHsfLabel('martyrs')}</h2><div className="flex_column">{details.members.map((member: any) => <div className="CardList" key={member.id}><Link className="icon" to={`/santoral/hijos-sagrada-familia/${member.id}`}><span className="CardListTitle">{member.name}</span></Link></div>)}</div></>}
          {entry.group_id && <div className="CardList"><Link className="icon" to={`/santoral/hijos-sagrada-familia/${entry.group_id}`}><span className="CardListTitle">{getHsfLabel('martyrs')}</span></Link></div>}
        </> : details && <div className="CardContents"><p>{getSantoralLabel('sin_resultados')}</p></div>}
      </div>
    </div>
  );
}
